import { FC } from 'react';
import { useQuery } from 'react-query';
import API from 'core/Api';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';
import { ISelectOptionProps } from 'components/form/types';
import { useLanguageContext } from 'store/language';
import InnerWrapper from '../../InnerWrapper';
import CreateForm from './components/CreateForm';
import { IDropdowns } from '../components/types';

const Screen: FC = () => {
  const { client } = useActiveClientContext();
  const { language } = useLanguageContext();

  const {
    isLoading: isLoadingUserDropdowns,
    error: errorUserDropdowns,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>([buildClientEntity('user-dropdowns', client)], (): Promise<IDropdowns> => {
    return API.get('users/dropdown-options?isNew=true').then(res => {
      return res.data && res.data[language || 'bg'];
    });
  });

  const {
    isLoading: isLoadingRoles,
    error: errorRoles,
    data: roles,
  } = useQuery<ISelectOptionProps[], Error>([buildClientEntity('roles', client)], (): Promise<ISelectOptionProps[]> => {
    return API.get('roles').then(
      res =>
        res.data &&
        res.data.items.map((role: { [key: string]: string | number }) => ({
          value: role.id,
          label: role.name,
        }))
    );
  });

  return (
    <InnerWrapper
      isLoading={isLoadingUserDropdowns && isLoadingRoles}
      error={errorUserDropdowns || errorRoles}
    >
      {dropdowns && roles && (
        <CreateForm
          roleOptions={roles}
          userDataOptions={dropdowns}
        />
      )}
    </InnerWrapper>
  );
};

export default Screen;
